/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_GS_71_83(e) {
  let t = (0, ReactCompiler.c)(7),
    { titulo: n, valor: r } = e,
    i;
  t[0] === n
    ? (i = t[1])
    : ((i = <dt className={`text-xs text-(--text)`} children={n} />),
      (t[0] = n),
      (t[1] = i));
  let a;
  t[2] === r
    ? (a = t[3])
    : ((a = <dd className={`text-(--text-h)`} children={r} />),
      (t[2] = r),
      (t[3] = a));
  let o;
  return (
    t[4] !== i || t[5] !== a
      ? ((o = <div children={[i, a]} />), (t[4] = i), (t[5] = a), (t[6] = o))
      : (o = t[6]),
    o
  );
}
